<!-- Export Certificate Modal -->
<div class="modal fade" id="kt_modal_vh_manager_export_certificate" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-xl">
    <div class="modal-content">
      <!-- Modal Header -->
      <div class="modal-header d-flex justify-content-between align-items-center bg-light">
        <h2 class="fw-bold mb-0 text-dark">{{ isEditMode ? 'Update Export Certificate' : 'Add Export Certificate' }}</h2>
        <div class="btn btn-icon btn-sm btn-active-icon-primary" data-bs-dismiss="modal">
          <i class="ki-duotone ki-cross fs-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
        </div>
      </div>

      <!-- Modal Body -->
      <div class="modal-body p-0">
        <form [formGroup]="exportCertificateForm" (ngSubmit)="onSubmit()" novalidate>

          <!-- Certificate Header -->
          <div class="certificate-header bg-white border-bottom p-4">
            <div class="row align-items-center">
              <div class="col-md-3">
                <div class="d-flex align-items-center">
                  <span class="badge badge-secondary fs-6 fw-bold px-3 py-2">EXP. CERT.</span>
                </div>
              </div>
              <div class="col-md-6 text-center">
                <h1 class="text-danger fw-bold fs-1 mb-0" style="letter-spacing: 3px;">EXPORT CERTIFICATE</h1>
              </div>
              <div class="col-md-3 text-end">
                <div class="text-muted fs-7">
                  <div class="fw-bold">Print All</div>
                  <div>COMPANY_PREFIX_ID NO.</div>
                </div>
              </div>
            </div>
          </div>

          <!-- Vehicle Selection -->
          <div class="certificate-info bg-white p-3 border-bottom">
            <div class="row mb-3">
              <div class="col-md-12">
                <label class="form-label fw-bold">Select Vehicle <span class="text-danger">*</span></label>
                <div class="position-relative">
                  <input
                    type="text"
                    class="form-control form-control-sm border-dark"
                    [(ngModel)]="vehicleSearchTerm"
                    [ngModelOptions]="{standalone: true}"
                    (input)="onVehicleSearchInput($event)"
                    (focus)="onVehicleInputFocus()"
                    (blur)="onVehicleInputBlur()"
                    placeholder="Search vehicles by name, company, or inventory number..."
                    autocomplete="off"
                    [disabled]="isVehiclePreSelected"
                  />

                  <!-- Loading indicator -->
                  <div *ngIf="isVehicleSearching" class="position-absolute top-50 end-0 translate-middle-y me-3">
                    <span class="spinner-border spinner-border-sm text-primary"></span>
                  </div>

                  <!-- Dropdown -->
                  <div *ngIf="showVehicleDropdown" class="dropdown-menu show w-100 mt-1" style="max-height: 300px; overflow-y: auto; z-index: 1050;">
                    <div *ngIf="vehicleSearchResults.length === 0 && !isVehicleSearching" class="dropdown-item-text text-muted">
                      No vehicles found
                    </div>
                    <div *ngFor="let vehicle of vehicleSearchResults"
                         class="dropdown-item cursor-pointer d-flex align-items-center py-3"
                         (click)="selectVehicle(vehicle)">
                      <!-- Vehicle Image -->
                      <div class="symbol symbol-40px me-3">
                        <img [src]="getVehicleImageUrl(vehicle)"
                             [alt]="vehicle.name || 'Vehicle'"
                             class="symbol-label"
                             style="object-fit: cover;">
                      </div>

                      <!-- Vehicle Details -->
                      <div class="flex-grow-1">
                        <div class="fw-bold text-dark">{{ vehicle.name || 'Unknown Vehicle' }}</div>
                        <div class="text-muted fs-7">
                          <span *ngIf="vehicle.company_name">{{ vehicle.company_name }}</span>
                          <span *ngIf="vehicle.company_name && vehicle.year"> • </span>
                          <span *ngIf="vehicle.year">{{ vehicle.year }}</span>
                        </div>
                        <div class="text-muted fs-8" *ngIf="vehicle.car_no">
                          Inventory: {{ vehicle.car_no }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Selected Vehicle Display -->
                <div *ngIf="selectedVehicle && isVehiclePreSelected" class="mt-2 p-2 bg-light rounded border">
                  <div class="d-flex align-items-center">
                    <div class="symbol symbol-40px me-3">
                      <img [src]="getVehicleImageUrl(selectedVehicle)"
                           [alt]="selectedVehicle.name || 'Vehicle'"
                           class="symbol-label"
                           style="object-fit: cover;">
                    </div>
                    <div class="flex-grow-1">
                      <div class="fw-bold text-dark">{{ selectedVehicle.name || 'Unknown Vehicle' }}</div>
                      <div class="text-muted fs-7">
                        <span *ngIf="selectedVehicle.company_name">{{ selectedVehicle.company_name }}</span>
                        <span *ngIf="selectedVehicle.company_name && selectedVehicle.year"> • </span>
                        <span *ngIf="selectedVehicle.year">{{ selectedVehicle.year }}</span>
                      </div>
                      <div class="text-muted fs-8" *ngIf="selectedVehicle.car_no">
                        Inventory: {{ selectedVehicle.car_no }}
                      </div>
                    </div>
                    <div class="badge badge-success">Pre-selected</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Row 1: Certificate No & Reference Number -->
          <div class="certificate-info bg-white p-3 border-bottom">
            <div class="row mb-3">
              <div class="col-md-6">
                <div class="d-flex align-items-center">
                  <label class="form-label fw-bold me-3 mb-0" style="min-width: 140px;">Certificate No. <span class="text-danger">*</span></label>
                  <div class="flex-grow-1">
                    <input type="text" class="form-control form-control-sm border-dark"
                           formControlName="certificate_no"
                           [class.is-invalid]="exportCertificateForm.get('certificate_no')?.invalid && exportCertificateForm.get('certificate_no')?.touched">
                    <div class="invalid-feedback" *ngIf="exportCertificateForm.get('certificate_no')?.invalid && exportCertificateForm.get('certificate_no')?.touched">
                      Certificate number is required.
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="d-flex align-items-center">
                  <label class="form-label fw-bold me-3 mb-0" style="min-width: 140px;">Reference Number</label>
                  <input type="text" class="form-control form-control-sm border-dark"
                         formControlName="reference_number">
                </div>
              </div>
            </div>
          </div>

          <!-- Row 2: Phone No -->
          <div class="certificate-info bg-white p-3 border-bottom">
            <div class="row mb-3">
              <div class="col-md-6">
                <div class="d-flex align-items-center">
                  <label class="form-label fw-bold me-3 mb-0" style="min-width: 140px;">Phone No</label>
                  <input type="text" class="form-control form-control-sm border-dark"
                         formControlName="phone_no">
                </div>
              </div>
            </div>
          </div>

          <!-- Row 3: Fax -->
          <div class="certificate-info bg-white p-3 border-bottom">
            <div class="row mb-3">
              <div class="col-md-6">
                <div class="d-flex align-items-center">
                  <label class="form-label fw-bold me-3 mb-0" style="min-width: 140px;">Fax</label>
                  <input type="text" class="form-control form-control-sm border-dark"
                         formControlName="fax">
                </div>
              </div>
            </div>
          </div>

          <!-- Row 4: Registration Details -->
          <div class="certificate-info bg-white p-3 border-bottom">
            <div class="row mb-3">
              <div class="col-md-3">
                <div class="d-flex align-items-center">
                  <label class="form-label fw-bold me-2 mb-0 fs-8">Registration No</label>
                  <input type="text" class="form-control form-control-sm border-dark"
                         formControlName="registration_no">
                </div>
              </div>
              <div class="col-md-3">
                <div class="d-flex align-items-center">
                  <label class="form-label fw-bold me-2 mb-0 fs-8">Registration Date</label>
                  <input type="text" class="form-control form-control-sm border-dark"
                         formControlName="registration_date">
                </div>
              </div>
              <div class="col-md-3">
                <div class="d-flex align-items-center">
                  <label class="form-label fw-bold me-2 mb-0 fs-8">First Reg. Date</label>
                  <input type="text" class="form-control form-control-sm border-dark"
                         formControlName="first_reg_date">
                </div>
              </div>
              <div class="col-md-3">
                <div class="d-flex align-items-center">
                  <label class="form-label fw-bold me-2 mb-0 fs-8">Maker's Serial Number</label>
                  <input type="text" class="form-control form-control-sm border-dark"
                         formControlName="makers_serial_number">
                </div>
              </div>
            </div>
          </div>

          <!-- Row 5: Trademark, Model, Engine Model -->
          <div class="certificate-info bg-white p-3 border-bottom">
            <div class="row mb-3">
              <div class="col-md-4">
                <div class="d-flex align-items-center">
                  <label class="form-label fw-bold me-2 mb-0 fs-8">Trademark of the maker</label>
                  <input type="text" class="form-control form-control-sm border-dark"
                         formControlName="trademark_maker">
                </div>
              </div>
              <div class="col-md-4">
                <div class="d-flex align-items-center">
                  <label class="form-label fw-bold me-2 mb-0 fs-8">Model</label>
                  <input type="text" class="form-control form-control-sm border-dark"
                         formControlName="model">
                </div>
              </div>
              <div class="col-md-4">
                <div class="d-flex align-items-center">
                  <label class="form-label fw-bold me-2 mb-0 fs-8">Engine Model</label>
                  <input type="text" class="form-control form-control-sm border-dark"
                         formControlName="engine_model">
                </div>
              </div>
            </div>
          </div>

          <!-- Row 6: Name of Owner -->
          <div class="certificate-info bg-white p-3 border-bottom">
            <div class="row mb-3">
              <div class="col-md-12">
                <div class="d-flex align-items-center">
                  <label class="form-label fw-bold me-3 mb-0" style="min-width: 140px;">Name of Owner</label>
                  <input type="text" class="form-control form-control-sm border-dark"
                         formControlName="name_of_owner">
                </div>
              </div>
            </div>
          </div>

          <!-- Row 7: Address of Owner -->
          <div class="certificate-info bg-white p-3 border-bottom">
            <div class="row mb-3">
              <div class="col-md-12">
                <div class="d-flex align-items-center">
                  <label class="form-label fw-bold me-3 mb-0" style="min-width: 140px;">Address of Owner</label>
                  <textarea class="form-control form-control-sm border-dark"
                            formControlName="address_of_owner" rows="2"></textarea>
                </div>
              </div>
            </div>
          </div>

          <!-- Row 8: Name of User -->
          <div class="certificate-info bg-white p-3 border-bottom">
            <div class="row mb-3">
              <div class="col-md-12">
                <div class="d-flex align-items-center">
                  <label class="form-label fw-bold me-3 mb-0" style="min-width: 140px;">Name of User</label>
                  <input type="text" class="form-control form-control-sm border-dark"
                         formControlName="name_of_user">
                </div>
              </div>
            </div>
          </div>

          <!-- Row 9: Address of User -->
          <div class="certificate-info bg-white p-3 border-bottom">
            <div class="row mb-3">
              <div class="col-md-12">
                <div class="d-flex align-items-center">
                  <label class="form-label fw-bold me-3 mb-0" style="min-width: 140px;">Address of User</label>
                  <textarea class="form-control form-control-sm border-dark"
                            formControlName="address_of_user" rows="2"></textarea>
                </div>
              </div>
            </div>
          </div>

          <!-- Row 10: Locality of principal abode of use -->
          <div class="certificate-info bg-white p-3 border-bottom">
            <div class="row mb-3">
              <div class="col-md-12">
                <div class="d-flex align-items-center">
                  <label class="form-label fw-bold me-3 mb-0" style="min-width: 200px;">Locality of principal abode of use</label>
                  <input type="text" class="form-control form-control-sm border-dark"
                         formControlName="locality_principal_abode">
                </div>
              </div>
            </div>
          </div>

          <!-- Row 11: Classification Details -->
          <div class="certificate-info bg-white p-3 border-bottom">
            <div class="row mb-2">
              <div class="col-md-3">
                <div class="d-flex align-items-center">
                  <label class="form-label fw-bold me-2 mb-0 fs-8">Classification of vehicle</label>
                  <input type="text" class="form-control form-control-sm border-dark"
                         formControlName="classification_of_vehicle">
                </div>
              </div>
              <div class="col-md-2">
                <div class="d-flex align-items-center">
                  <label class="form-label fw-bold me-2 mb-0 fs-8">Use</label>
                  <input type="text" class="form-control form-control-sm border-dark"
                         formControlName="use">
                </div>
              </div>
              <div class="col-md-2">
                <div class="d-flex align-items-center">
                  <label class="form-label fw-bold me-2 mb-0 fs-8">Purpose</label>
                  <input type="text" class="form-control form-control-sm border-dark"
                         formControlName="purpose">
                </div>
              </div>
              <div class="col-md-2">
                <div class="d-flex align-items-center">
                  <label class="form-label fw-bold me-2 mb-0 fs-8">Type of Body</label>
                  <input type="text" class="form-control form-control-sm border-dark"
                         formControlName="type_of_body">
                </div>
              </div>
              <div class="col-md-3">
                <div class="d-flex align-items-center">
                  <label class="form-label fw-bold me-2 mb-0 fs-8">Fixed Number</label>
                  <input type="text" class="form-control form-control-sm border-dark"
                         formControlName="fixed_number">
                </div>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-md-3">
                <div class="d-flex align-items-center">
                  <label class="form-label fw-bold me-2 mb-0 fs-8">Maximum Carry</label>
                  <input type="text" class="form-control form-control-sm border-dark"
                         formControlName="maximum_carry">
                </div>
              </div>
              <div class="col-md-3">
                <div class="d-flex align-items-center">
                  <label class="form-label fw-bold me-2 mb-0 fs-8">Weight</label>
                  <input type="text" class="form-control form-control-sm border-dark"
                         formControlName="weight">
                </div>
              </div>
              <div class="col-md-3">
                <div class="d-flex align-items-center">
                  <label class="form-label fw-bold me-2 mb-0 fs-8">G/Weight</label>
                  <input type="text" class="form-control form-control-sm border-dark"
                         formControlName="g_weight">
                </div>
              </div>
            </div>
          </div>

          <!-- Row 12: Engine and Dimension Details -->
          <div class="certificate-info bg-white p-3 border-bottom">
            <div class="row mb-2">
              <div class="col-md-2">
                <div class="d-flex align-items-center">
                  <label class="form-label fw-bold me-2 mb-0 fs-8">Engine Capacity</label>
                  <input type="text" class="form-control form-control-sm border-dark"
                         formControlName="engine_capacity">
                </div>
              </div>
              <div class="col-md-2">
                <div class="d-flex align-items-center">
                  <label class="form-label fw-bold me-2 mb-0 fs-8">Classification of fuel</label>
                  <input type="text" class="form-control form-control-sm border-dark"
                         formControlName="classification_of_fuel">
                </div>
              </div>
              <div class="col-md-2">
                <div class="d-flex align-items-center">
                  <label class="form-label fw-bold me-2 mb-0 fs-8">Specification No.</label>
                  <input type="text" class="form-control form-control-sm border-dark"
                         formControlName="specification_no">
                </div>
              </div>
              <div class="col-md-2">
                <div class="d-flex align-items-center">
                  <label class="form-label fw-bold me-2 mb-0 fs-8">Classification No.</label>
                  <input type="text" class="form-control form-control-sm border-dark"
                         formControlName="classification_no">
                </div>
              </div>
              <div class="col-md-2">
                <div class="d-flex align-items-center">
                  <label class="form-label fw-bold me-2 mb-0 fs-8">Length</label>
                  <input type="text" class="form-control form-control-sm border-dark"
                         formControlName="length">
                </div>
              </div>
              <div class="col-md-2">
                <div class="d-flex align-items-center">
                  <label class="form-label fw-bold me-2 mb-0 fs-8">Width</label>
                  <input type="text" class="form-control form-control-sm border-dark"
                         formControlName="width">
                </div>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-md-2">
                <div class="d-flex align-items-center">
                  <label class="form-label fw-bold me-2 mb-0 fs-8">Height</label>
                  <input type="text" class="form-control form-control-sm border-dark"
                         formControlName="height">
                </div>
              </div>
              <div class="col-md-2">
                <div class="d-flex align-items-center">
                  <label class="form-label fw-bold me-2 mb-0 fs-8">F.Weight</label>
                  <input type="text" class="form-control form-control-sm border-dark"
                         formControlName="f_weight">
                </div>
              </div>
              <div class="col-md-2">
                <div class="d-flex align-items-center">
                  <label class="form-label fw-bold me-2 mb-0 fs-8">FR Weight</label>
                  <input type="text" class="form-control form-control-sm border-dark"
                         formControlName="fr_weight">
                </div>
              </div>
              <div class="col-md-2">
                <div class="d-flex align-items-center">
                  <label class="form-label fw-bold me-2 mb-0 fs-8">RF Weight</label>
                  <input type="text" class="form-control form-control-sm border-dark"
                         formControlName="rf_weight">
                </div>
              </div>
              <div class="col-md-2">
                <div class="d-flex align-items-center">
                  <label class="form-label fw-bold me-2 mb-0 fs-8">R Weight</label>
                  <input type="text" class="form-control form-control-sm border-dark"
                         formControlName="r_weight">
                </div>
              </div>
            </div>
          </div>

          <!-- Row 13: Export Scheduled Day -->
          <div class="certificate-info bg-white p-3 border-bottom">
            <div class="row mb-3">
              <div class="col-md-6">
                <div class="d-flex align-items-center">
                  <label class="form-label fw-bold me-3 mb-0" style="min-width: 160px;">Export Scheduled Day</label>
                  <input type="date" class="form-control form-control-sm border-dark"
                         formControlName="export_scheduled_day">
                </div>
              </div>
            </div>
          </div>

          <!-- Remarks Section -->
          <div class="remarks-section bg-white p-4 border-bottom">
            <h6 class="fw-bold mb-3">Remarks</h6>
            <div class="row mb-3">
              <div class="col-md-12">
                <textarea class="form-control form-control-sm border-dark"
                          formControlName="remarks" rows="3"
                          placeholder="Enter remarks"></textarea>
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-md-4">
                <div class="d-flex align-items-center">
                  <label class="form-label fw-bold me-2 mb-0 fs-8">Old Vehicle Registration No.</label>
                  <input type="text" class="form-control form-control-sm border-dark"
                         formControlName="old_vehicle_registration_no">
                </div>
              </div>
              <div class="col-md-4">
                <div class="d-flex align-items-center">
                  <label class="form-label fw-bold me-2 mb-0 fs-8">Latest Owner Name & Registration</label>
                  <input type="text" class="form-control form-control-sm border-dark"
                         formControlName="latest_owner_name_registration">
                </div>
              </div>
              <div class="col-md-4">
                <div class="d-flex align-items-center">
                  <label class="form-label fw-bold me-2 mb-0 fs-8">Date of Application</label>
                  <input type="date" class="form-control form-control-sm border-dark"
                         formControlName="date_of_application">
                </div>
              </div>
            </div>
          </div>

          <!-- Final Date and Director General Section -->
          <div class="final-section bg-white p-4 border-bottom">
            <div class="row mb-3">
              <div class="col-md-6">
                <div class="d-flex align-items-center">
                  <label class="form-label fw-bold me-3 mb-0" style="min-width: 100px;">Date</label>
                  <input type="date" class="form-control form-control-sm border-dark"
                         formControlName="final_date">
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 text-center">
                <p class="fw-bold fs-6 mb-0">Director General</p>
                <p class="text-muted fs-7 mb-0">Ministry of Land, Infrastructure, Transport and Tourism</p>
              </div>
            </div>
          </div>



        </form>
      </div>

      <!-- Modal Footer -->
      <div class="modal-footer d-flex justify-content-between align-items-center bg-light">
        <div class="text-muted fs-7">
          <span *ngIf="selectedVehicle">
            Vehicle: {{ selectedVehicle.make }} {{ selectedVehicle.model }}
            ({{ selectedVehicle.year }}) - {{ selectedVehicle.chassis_no }}
          </span>
        </div>
        <div class="d-flex gap-2">
          <button type="button" class="btn btn-light btn-sm" data-bs-dismiss="modal">
            <i class="ki-duotone ki-cross fs-2">
              <span class="path1"></span>
              <span class="path2"></span>
            </i>
            Cancel
          </button>
          <button type="button" class="btn btn-primary btn-sm"
                  (click)="onSubmit()"
                  [disabled]="isLoading">
            <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-2"></span>
            <i class="ki-duotone ki-printer fs-2 me-1" *ngIf="!isLoading">
              <span class="path1"></span>
              <span class="path2"></span>
            </i>
            {{ isLoading ? (isEditMode ? 'Updating...' : 'Generating...') : (isEditMode ? 'Update Certificate' : 'Generate Certificate') }}
          </button>
        </div>
      </div>

    </div>
  </div>
</div>
